import React from 'react';

interface LegendPayload {
    value: string;
}

interface CustomLegendProps {
    payload: LegendPayload[];
    strategyColorMap: Record<string, string>;
}

export const CustomLegend = ({ payload, strategyColorMap }: CustomLegendProps) => {
    const uniqueStrategies = Array.from(new Map(payload.map((item) => [item.value, item])).values());

    return (
        <div className="mt-4 flex flex-wrap justify-center gap-4">
            {uniqueStrategies.map((entry) => (
                <div key={entry.value} className="flex items-center gap-2">
                    <div className="h-3 w-3 rounded-sm" style={{ backgroundColor: strategyColorMap[entry.value] }} />
                    <span className="text-sm">{entry.value}</span>
                </div>
            ))}
        </div>
    );
};
